module.exports = __webpack_public_path__ + "static/media/MenuStrawberrySalad.6f742fbc.jpg";